import React, { useEffect, useRef, useState } from 'react';
import WaveSurfer from 'wavesurfer.js';
import './AudioWaveForm.less';
export default function AudioWaveform({
  audioUrl = 'https://staging.talecast.ai/resource/user/300557252547313664/project/1750999238579001/separate/_instrumental.wav',
  startTime = 0,
  endTime = 80,
  waveWidth = 500,
  waveformCompleteWidth = 1000,
}) {
  const waveformRef = useRef(null);
  const wavesurferRef = useRef(null);
  const waveformBoxRef = useRef(null);
  const [wavesurferState, setWavesurferState] = useState(false);

  useEffect(() => {
    if (!waveformRef.current || !audioUrl) return;
    setWavesurferState(true);
    console.log(waveformCompleteWidth, 'waveformCompleteWidthwaveformCompleteWidth');
    // 初始化 Wavesurfer
    const wavesurfer = WaveSurfer.create({
      container: waveformRef.current,
      waveColor: '#00000050', // 波形颜色
      cursorColor: 'transparent', // 隐藏光标
      barWidth: 2, // 波形条宽度
      barGap: 1, // 波形条间距
      height: 36, // 波形高度
      interact: false, // 禁用交互（如点击跳转）
      hideScrollbar: true, // 关键参数：禁用滚动条
      barAlign: 'bottom',
    });

    wavesurferRef.current = wavesurfer;
    wavesurfer.load(audioUrl);
    // const duration = endTime - startTime;
    wavesurfer.on('ready', () => {
      console.log(startTime, endTime, audioUrl, 'startTime, endTime');
      // // 设置当前时间为开始时间
      // wavesurfer.setTime(startTime);

      // // // 计算合适的缩放级别以显示指定时间段
      // const containerWidth = waveWidth;
      // const pixelsPerSecond = containerWidth / duration;
      // waveformBoxRef.current.scrollLeft = startTime * sWidth;
      const duration = endTime - startTime;
      const containerWidth = waveWidth;
      const pixelsPerSecond = containerWidth / duration;
      waveformBoxRef.current.scrollLeft = startTime * pixelsPerSecond;
      // 设置缩放级别
      // wavesurfer.zoom(pixelsPerSecond);
      // 设置最小像素/秒，使整个时间段适合容器宽度
      // const containerWidth = waveWidth;
      // wavesurfer.params.minPxPerSec = containerWidth / duration;
      // wavesurfer.drawBuffer();

      // // 滚动到指定开始时间
      // wavesurfer.scroll(startTime);

      setWavesurferState(false);
    });
    const div = waveformBoxRef.current;
    if (!div) return;

    const handleWheel = (e) => {
      // 检测是否同时按下了Shift键
      if (e.shiftKey) {
        e.preventDefault();
      }
      // 允许正常的垂直滚动
    };

    div.addEventListener('wheel', handleWheel, { passive: false });

    return () => {
      div.removeEventListener('wheel', handleWheel);
      wavesurfer.destroy();
    };
  }, [waveformCompleteWidth, waveWidth]);

  // function zoomToTimeRange(wavesurfer, startTime, endTime) {
  //   // 确保时间范围有效
  //   if (startTime >= endTime || startTime < 0 || endTime > wavesurfer.getDuration()) {
  //     console.error('Invalid time range');
  //     return;
  //   }
  //   console.log(wavesurfer, 'wavesurfer');

  //   // 计算时间范围和所需缩放级别
  //   const durationToShow = endTime - startTime;
  //   const containerWidth = wavesurfer.renderer.getWidth();
  //   const minPxPerSec = containerWidth / durationToShow;

  //   // 设置参数并重新绘制
  //   // wavesurfer.options.minPxPerSec = minPxPerSec;
  //   // wavesurfer.drawBuffer();
  //   wavesurfer.setOptions({
  //     minPxPerSec: minPxPerSec,
  //   });
  //   setWavesurferState(false);
  //   // 定位到开始时间
  //   wavesurfer.setTime(startTime);
  // }

  return (
    <div
      ref={waveformBoxRef}
      className="audioWaveform_box"
      style={{ width: waveWidth ? `${waveWidth}px` : '100%', overflow: 'auto' }}>
      <div ref={waveformRef} style={{ width: `${waveformCompleteWidth}px` }}></div>
      {wavesurferState && (
        <span
          className="loading loading-spinner loading-xs"
          style={{
            position: 'absolute',
            top: '50%',
            left: '12px',
            transform: 'translateY(-50%)',
          }}></span>
      )}
    </div>
  );
}
